


export default function ProjectDetailsThumbnail({
    src,
    alt="Project Thumbnail Image"
}){


    return (
        <>
            <div
                className="
                    w-full

                    flex
                    justify-center
                    
                    my-14
                "
            >

                <div
                    className="
                        w-[325px]
                        h-[400px]

                        sm:w-[450px]
                        sm:h-[500px]

                        md:w-[550px]
                        md:h-[600px]

                        lg:w-[700px]
                        lg:h-[700px]

                        xl:w-[1000px]
                        xl:h-[700px]
                    "
                >
                    <img
                        src={src}
                        alt={alt}
                        className="
                            object-contain
                            h-full
                            w-full
                        "
                    />
                </div>



            </div>
        </>
    );

}